import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import Moment from 'moment';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';
import isEqual from 'lodash/isEqual';
import TableList from '../../components/TableList';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { AppSettings } from '../../constants';
import {
  initialSizePerPage,
  dispatchActionSetPageSizeReference
} from 'helper/unit-helper';
import * as RFSActionType from '../constants';
import * as AuthActionType from 'Auth/constants';
import * as BuilderActionType from 'Builders/constants';
import RFSFilter from '../Components/RFSFilter';
import { ChangeColumn } from 'components/change-column';
import SplitButtonDropdowns from 'components/split-button-dropdowns';
import Translate from '../../components/translate';
import { ExportButton } from 'Work-Orders/Components/ExportButton';
import { Dropdown } from 'components/Dropdown/Dropdown';
import ReassignMultiplePopup from '../Components/ReassignMultiplePopup';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { SortCaret } from 'Lots/Components/SortCaret';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending',
  sizePerPage: 10
};

const TABLE_NAME = 'RFS_LIST';

const headerOptions = [
  {
    value: 0,
    text: 'Bulk actions'
  },
  {
    value: 1,
    text: 'Reassign'
  }
];

class ManageRFS extends Component {
  static propTypes = {
    ManagerStore: PropTypes.object,
    ManageSubcontractor: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
    SelectListRegions: PropTypes.array,
    SelectListMarkets: PropTypes.array,
    SelectListProjects: PropTypes.array,
    builderUserList: PropTypes.array,
    SelectListRequestType: PropTypes.array,
    SelectListLots: PropTypes.array,
    UserProfile: PropTypes.object,
    SettingDataGridColumn: PropTypes.object,
    PageSizeReference: PropTypes.object,
    CreatedByList:PropTypes.array
  };

  constructor(props) {
    super(props);

    this.sizePerPage = initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.ManagerStore.ManageRFS.params.take
    );

    this.queryParams = queryString.parse(this.props.location.search);

    this.state = {
      sizePerPage: this.queryParams.take
        ? Number(this.queryParams.take)
        : this.sizePerPage,
      currentPage: this.queryParams.skip
        ? Number(this.queryParams.skip)
        : props.ManagerStore.ManageRFS.params.skip,
      totalRecord: props.ManagerStore.ManageRFS.params.totalRecord,
      defaultSortName: this.queryParams.sortField
        ? this.queryParams.sortField
        : defaultParams.defaultSortName,
      defaultSortOrder: this.queryParams.sortOrder
        ? this.queryParams.sortOrder
        : defaultParams.defaultSortOrder,
      data: props.ManagerStore.ManageRFS.items,
      paramFilter: null,
      column: [
        {
          field: 'refNo',
          header: 'RFS#',
          hidden: false,
          isKey: true,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'number',
          customRender: this.customRenderRFSID.bind(this)
        },
        {
          field: 'originalRefNo',
          header: 'Legacy ID (v3)',
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'legacyWO',
          customRender: this.customRenderOriginalRefNoV3.bind(this)
        },
        {
          field: 'createdDate',
          header: 'Created',
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderCreatedDate.bind(this)
        },
        {
          field: 'projectName',
          header: <Translate translateKey='project' capitalize />,
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderProjectName.bind(this)
        },
        {
          field: 'lotName',
          header: (
            <span>
              <Translate translateKey='lot' capitalize /> #
            </span>
          ),
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'createdByName',
          header: (
            <span>
              <Translate translateKey='Created by' capitalize />
            </span>
          ),
          isKey: false,
          sort: true,
          hidden:true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'streetAddress',
          header: 'Street address',
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'address'
        },
        {
          field: 'requestTypeName',
          header: 'Request type',
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'managedByUserName',
          header: 'Managed by',
          hidden: true,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'statusValue',
          header: 'Status',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderStatus.bind(this)
        },
        {
          field: 'scheduleDate',
          header: 'Scheduled date',
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderScheduleDate.bind(this)
        },
        {
          field: 'numberOfWOs',
          header: '# of WOs',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'number'
        },
        {
          field: '',
          header: '',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'right',
          headerAlign: 'right',
          customRender: this.customRenderBtnAction.bind(this),
          widthStyle: 'number'
        }
      ],
      RfsDefaultConfigValue: this.props.history.action === 'POP' ? true : false,
      settingColumn: [],
      searchTxt: this.queryParams.searchKey || '',
      isDisplayTable: true,
      refNoCheckList: {},
      headerOptions: headerOptions,
      headerAction: headerOptions[0],
      isDisplayReassignPopup: false
    };
  }

  componentDidMount() {
    if (this.queryParams.skip) {
      this.binding(
        this.objToParams({
          ...this.queryParams,
          skip: this.queryParams.skip ? this.queryParams.skip : 1,
          NewRFSFilterFromTiles: this.queryParams.NewRFSFilterFromTiles ? this.queryParams.NewRFSFilterFromTiles : 0,
          RfsDefaultConfig: this.queryParams.NewRFSFilterFromTiles == 'True' ? false : true,
        })
      );
    } else {
      this.binding(
        this.objToParams({
          ...this.props.ManagerStore.ManageRFS.params,
          take: this.state.sizePerPage,
          NewRFSFilterFromTiles: this.queryParams.NewRFSFilterFromTiles ? this.queryParams.NewRFSFilterFromTiles : 0,
          RfsDefaultConfig: this.queryParams.NewRFSFilterFromTiles == 'True' ? false : true,
        })
      );
    }

    if (
      this.props.UserProfile &&
      this.props.UserProfile.userId &&
      this.props.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        this.props.UserProfile.userId,
        this.props.SettingDataGridColumn
      );
    }

    if (this.queryParams.take) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        Number(this.queryParams.take)
      );
    }

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const ManageRFSs = nextProps.ManagerStore.ManageRFS;
    if (ManageRFSs) {
      const uniqueRFS = {}; // Temporary object to store unique IDs
      const updatedRFSList = ManageRFSs.items.filter(item => {
        if (!uniqueRFS[item.id]) {
          uniqueRFS[item.id] = true;
          return true;
        }
        return false;
      });

      this.setState({
        totalRecord: ManageRFSs.params.totalRecord,
        data: updatedRFSList,
        currentPage: ManageRFSs.params.skip
      });

      let pagingButtons = document.getElementsByClassName('page-link');

      Array.prototype.forEach.call(pagingButtons, el => {
        el.blur();
      });
    }
    if (
      nextProps.UserProfile &&
      nextProps.UserProfile.userId &&
      nextProps.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        nextProps.UserProfile.userId,
        nextProps.SettingDataGridColumn
      );
    }

    const urlParams = queryString.parse(nextProps.location.search);

    if (typeof urlParams.searchKey !== 'undefined') {
      this.setState({ searchTxt: urlParams.searchKey });
    } else {
      this.setState({ searchTxt: '' });
    }

    if (!urlParams.skip) {
      this.setState({
        defaultSortName: defaultParams.defaultSortName,
        defaultSortOrder: defaultParams.defaultSortOrder
      });
    }

    if (
      urlParams.sortField &&
      urlParams.sortField !== this.state.defaultSortName
    ) {
      this.setState({ defaultSortName: urlParams.sortField });
    }

    if (
      urlParams.sortOrder &&
      urlParams.sortOrder !== this.state.defaultSortOrder
    ) {
      this.setState({ defaultSortOrder: urlParams.sortOrder });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }

    if (!isEqual(this.props.location.search, prevProps.location.search)) {
      let urlParams = queryString.parse(this.props.location.search);

      const {
        ManagerStore: {
          ManageRFS: { params }
        }
      } = this.props;

      if (urlParams.skip) {
        this.binding(
          this.objToParams({
            ...params,
            ...urlParams,
            skip: urlParams.skip
          })
        );
      } else {
        this.binding(
          this.objToParams({
            sortField: defaultParams.defaultSortName,
            sortOrder: defaultParams.defaultSortOrder,
            skip: 1,
            take: this.state.sizePerPage
          })
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RFSActionType.RESET_RFS
    });
  }

  setDefaultColumn = (userId, settingDataGridColumnProps) => {
    if (
      settingDataGridColumnProps.hasOwnProperty(userId) &&
      settingDataGridColumnProps[userId].hasOwnProperty('RFS_COLUMN')
    ) {
      const selectedColumnFields =
        settingDataGridColumnProps[userId].RFS_COLUMN;
      this.setState({ settingColumn: selectedColumnFields });
      const newColumnState = [...this.state.column];
      newColumnState.map(column => {
        if (column.field !== '') {
          if (selectedColumnFields.indexOf(column.field) !== -1) {
            column.hidden = false;
          } else {
            column.hidden = true;
          }
        }
      });
      this.setState({ column: newColumnState });
    }
  };

  onChangeColumn = (newColumn, selectedColumnField) => {
    this.setState({ isDisplayTable: false }, () => {
      this.props.dispatch({
        type: BuilderActionType.SET_SELECT_COLUMN,
        params: {
          id: this.props.UserProfile.userId,
          type: 'RFS_COLUMN',
          data: selectedColumnField
        }
      });

      setTimeout(() => {
        this.setState({ isDisplayTable: true });
      }, 200);
    });
  };

  binding(params) {
    this.props.dispatch({
      type: RFSActionType.SEARCH_RFS_ASYNC,
      params: params
    });
  }

  onSearch() {
    let urlParams = queryString.parse(this.props.location.search);

    const {
      searchTxt,
      defaultSortName,
      defaultSortOrder,
      sizePerPage
    } = this.state;

    urlParams['searchKey'] = searchTxt.trim();
    urlParams['sortField'] = defaultSortName;
    urlParams['sortOrder'] = defaultSortOrder;
    urlParams['skip'] = 1;
    urlParams['take'] = sizePerPage;
    urlParams = pickBy(urlParams);

    this.props.history.push({
      search: queryString.stringify(urlParams)
    });
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  objToParams(obj) {
    const urlParams = queryString.parse(this.props.location.search);
    let rfsDC;

    if(this.queryParams.NewRFSFilterFromTiles == 'True'){
      rfsDC = false
    }else{
      if(obj.RfsDefaultConfig){
        if(this.state.RfsDefaultConfigValue == true && this.props.ManagerStore.RFSDefaultConfigApplied.RfsDefaultConfig == true){
          rfsDC = true
        }else if(this.state.RfsDefaultConfigValue == true && this.props.ManagerStore.RFSDefaultConfigApplied.RfsDefaultConfig == false){
          rfsDC = false
        }else{
          if(obj.inRegions || obj.inMarkets || obj.inProjects || obj.Status || obj.inLot || obj.inRFSManagedBy || obj.inRequestTypes || obj.CreatedDateFrom || obj.inCreatedBy || obj.RFSWOAssignedMode){
            rfsDC = false
          }else{
            rfsDC = true
          }
        }
      }else{
        rfsDC = false
      }
    }

    return {
      searchKey:
        typeof urlParams.searchKey !== 'undefined'
          ? urlParams.searchKey
          : this.state.searchTxt.trim(),
      sortField: obj.sortField ? obj.sortField : obj.sort.field,
      sortOrder: obj.sortOrder ? obj.sortOrder : obj.sort.order,
      Skip: obj.skip - 1,
      Take: obj.take,
      RegionIds: this.processMultiParams(obj.inRegions),
      MarketIds: this.processMultiParams(obj.inMarkets),
      ProjectIds: this.processMultiParams(obj.inProjects),
      Status: obj.Status || '',
      LotIds: obj.inLot ? queryString.parse(obj.inLot).value : '',
      ManagedByUserIds: this.processMultiParams(obj.inRFSManagedBy),
      RequestTypeIds: this.processMultiParams(obj.inRequestTypes),
      CreatedDateFrom: obj.CreatedDateFrom || '',
      CreatedDateTo: obj.CreatedDateTo || '',
      CreatedBy:obj.inCreatedBy ? queryString.parse(obj.inCreatedBy).value : '',
      RFSWOAssignedMode: obj.RFSWOAssignedMode == undefined ? '' : obj.RFSWOAssignedMode,
      RfsDefaultConfig: rfsDC,
      NewRFSFilterFromTiles: obj.NewRFSFilterFromTiles == 'True' ? this.queryParams.NewRFSFilterFromTiles : 0
    };
  }

  processMultiParams = stringParams => {
    let params = [];
    if (stringParams) {
      const parsedParams = queryString.parse(stringParams);

      Object.keys(parsedParams).map(el => {
        params.push(queryString.parse(parsedParams[el]).value);
      });
    }
    return params.toString();
  };

  onFetchRegion = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_REGION_ASYNC,
      params: {
        ProjectIds: params.projectId,
        MarketIds: params.marketId,
        LotIds: params.lotId
      }
    });
  };

  onFetchRequestType = () => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_REQUEST_TYPE_ASYNC,
      params: { searchKey: '' }
    });
  };

  onFetchMarket = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_MARKET_ASYNC,
      params: {
        ProjectIds: params.projectId,
        RegionIds: params.regionId,
        LotIds: params.lotId
      }
    });
  };

  onFetchProject = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_PROJECT_ASYNC,
      params: {
        RegionIds: params.regionId,
        MarketIds: params.marketId,
        LotIds: params.lotId
      }
    });
  };

  onFetchLot = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_LOT_ASYNC,
      params: {
        RegionIds: params.regionId,
        MarketIds: params.marketId,
        ProjectIds: params.projectId
      }
    });
  };

  onFetchCreatedBy = (params) => {
    this.props.dispatch({
      type: RFSActionType.FETCH_CREATED_BY_RFS,
      params: {
        RegionIds: params.regionId,
        MarketIds: params.marketId,
        ProjectIds: params.projectId,
      }
    });
  };
  onFetchRFSManagedBy = () => {
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  };

  onSearchRFS = data => {
    const {
      ManagerStore: {
        ManageRFS: { params }
      }
    } = this.props;

    const { defaultSortName, defaultSortOrder } = this.state;
    let filterParams = Object.assign({ ...params }, data);

    delete filterParams.totalPage;
    delete filterParams.totalRecord;
    delete filterParams.sort;
    filterParams.sortField = defaultSortName;
    filterParams.sortOrder = defaultSortOrder;
    filterParams = pickBy(filterParams);

    this.props.history.push({
      search: queryString.stringify({
        ...filterParams,
        skip: 1,
      })
    });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        currentPage: params.currentPage,
        sizePerPage: params.sizePerPage
      },
      () => {
        let urlParams = queryString.parse(this.props.location.search);
        urlParams['searchKey'] = this.state.searchTxt.trim();
        urlParams['sortField'] = params.defaultSortName;
        urlParams['sortOrder'] = params.defaultSortOrder;
        urlParams['skip'] = params.currentPage;
        urlParams['take'] = params.sizePerPage;
        urlParams = pickBy(urlParams);

        this.props.history.push({
          search: queryString.stringify(urlParams)
        });
      }
    );
  }

  onContextMenu(e, item) {
    let contextItem = [];
    if (item.status !== 4) {
      contextItem = [
        {
          title: 'View detail',
          icon: '',
          event: this.onViewDetail.bind(this)
        },
        {
          title: 'Add new work order',
          icon: '',
          disabled: item.status === 3 ? true : false,
          event: this.onAddNewWorkOrder.bind(this)
        }
      ];
    } else {
      contextItem = [
        {
          title: 'View detail',
          icon: '',
          event: this.onViewDetail.bind(this)
        }
      ];
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onViewDetail(e, item) {
    e.preventDefault();
    this.props.history.push(`/request-for-services/${item.refNo}`);
  }

  onAddNewWorkOrder(e, item) {
    e.preventDefault();
    this.props.history.push(
      `/request-for-services/work-order/add/${item.refNo}`
    );
  }

  customRenderRFSID(item) {
    return (
      <span>
        <Link to={`/request-for-services/${item.refNo}`}>{item.refNo}</Link>
      </span>
    );
  }

  customRenderCreatedDate(item) {
    return <span>{Moment(item.createdDate).format('MM/DD/YYYY')}</span>;
  }

  customRenderOriginalRefNoV3(item) {
    if (item.originalRefNo !== null) {
      return (<span>{item.originalRefNo}</span>);
    }
    return '-';
  }

  customRenderStatus(item) {
    return (
      <span>
        {AppSettings.RFS_STATUS_VALUE.find(x => x.key === item.status).value}
      </span>
    );
  }

  customRenderScheduleDate(item) {
    return <span>{Moment(item.scheduleDate).format('MM/DD/YYYY')}</span>;
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  onChangeSearchTxt = e => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ searchTxt: e.target.value });
    }
  };

  toolTip(message) {
    return (
      <Tooltip
        className='in tooltip-siteone'
        placement='top'
        id='tooltip'
        positionLeft={0}
        arrowOffsetLeft={0}
      >
        <span
          style={{
            wordBreak: 'break-all',
            maxWidth: 200
          }}
        >
          {message}
        </span>
      </Tooltip>
    );
  }

  customRenderProjectName(item) {
    return (
      <OverlayTrigger
        placement='top'
        overlay={this.toolTip(item.projectName)}
        delayHide={10}
        delayShow={500}
      >
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
        >
          {item.projectName}
        </div>
      </OverlayTrigger>
    );
  }

  handleExport = () => {
    const {
      ManagerStore: {
        ManageRFS: { params }
      }
    } = this.props;

    let exportParams = {};
    let urlParams = queryString.parse(this.props.location.search);

    if (urlParams.skip) {
      exportParams = { ...urlParams, skip: 1, take: '' };
    } else {
      exportParams = { ...params, skip: 1, take: '' };
    }

    this.props.dispatch({
      type: RFSActionType.EXPORT_RFS_LIST,
      params: {...this.objToParams(exportParams), timeZoneOffset: -(new Date()).getTimezoneOffset()}

    });
  };

  onChangeHeaderAction = event => {
    this.setState({
      headerAction: event.value
    });
    this.onApplyAction(event.value.value, this.props);
  };

  onApplyAction = value => {
    if (value === 1) {
      const checkboxColumn = {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        columnClassName: 'td-width-50-px',
        customRender: this.customRenderCheckboxColumn.bind(this)
      };
      const newColumnState = [...this.state.column];
      newColumnState.unshift(checkboxColumn);
      this.setState({
        column: newColumnState
      });
    } else {
      const newColumnState = [...this.state.column];
      newColumnState.shift();
      this.setState({
        column: newColumnState
      });
    }
  };

  popoverRight() {
    return (
      <Popover id='popover-positioned-right' className='sign-off-error-popover'>
        <span>At least one request must be selected.</span>
      </Popover>
    );
  }

  toolTipCheckbox() {
    return (
      <Tooltip
        id='sign_off_multiple_work_order_tooltip'
        className='in tooltip-siteone'
      >
        <span>
          Only work orders with status Awaiting review/Pending/Open can be
          selected.
        </span>
      </Tooltip>
    );
  }

  onChecked = refNo => {
    if (!this.state.refNoCheckList[refNo]) {
      this.setState({
        refNoCheckList: {
          ...this.state.refNoCheckList,
          [refNo]: !this.state.refNoCheckList[refNo]
        }
      });
    } else {
      let newCheckList = { ...this.state.refNoCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoCheckList: newCheckList
      });
    }
  };

  onClickGoReassignMultiplePopup = () => {
    this.setState({
      isDisplayReassignPopup: !this.state.isDisplayReassignPopup
    });
  };

  onSaveReassignMultiple = user => {
    const { refNoCheckList } = this.state;

    let workOrderIds = [];

    Object.keys(refNoCheckList).forEach(key => {
      if (refNoCheckList[key]) {
        workOrderIds.push(parseInt(key));
      }
    });

    this.props.dispatch({
      type: RFSActionType.REASSIGN_MULTIPLE_RFS_ASYNC,
      params: {
        refNos: workOrderIds,
        managedByUserId: user.value
      },
      callback: () => {
        this.setState({
          isDisplayReassignPopup: false,
          headerAction: headerOptions[0]
        });

        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
          refNoCheckList: {}
        });

        this.binding(
          this.objToParams({
            ...this.props.ManagerStore.ManageRFS.params,
            take: this.state.sizePerPage
          })
        );
      }
    });
  };

  onFetchUserToReassign = () => {
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  };

  customRenderCheckboxColumn(item) {
    const { refNo } = item;

    const { refNoCheckList } = this.state;

    return (
      <CheckBoxSingle
        checked={
          refNoCheckList[refNo] !== null && refNoCheckList[refNo] === true
        }
        ref={c => {
          this.check = c;
        }}
        name='checkToSignoff'
        className='checkbox-default'
        onChecked={() => this.onChecked(refNo)}
        style={{ marginTop: -7 }}
      />
    );
  }

  getCaret = (direction, fieldName) => {
    const { defaultSortName, defaultSortOrder } = this.state;

    if (fieldName === defaultSortName) {
      if (defaultSortOrder === 'ascending') {
        return <SortCaret className='order dropup' />;
      } else {
        return <SortCaret className='order' />;
      }
    }

    return null;
  };

  render() {
    const data = this.state.data || [];

    const {
      column,
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      currentPage,
      totalRecord,
      headerAction,
      refNoCheckList,
      isDisplayReassignPopup,
      settingColumn,
      searchTxt,
      isDisplayTable
    } = this.state;

    const options = {
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12}>
            <Row>
              <Col sm={4}>
                <ul className='rfs-detail-table-header'>
                  <li>
                    <Dropdown
                      onChange={this.onChangeHeaderAction}
                      filter={true}
                      className='filestring-dropdown filter-dropdown'
                      options={headerOptions}
                      optionLabel='text'
                      value={headerAction}
                      style={{ width: 200, margin: 0 }}
                    />
                  </li>
                  {headerAction.value === 1 &&
                    Object.keys(refNoCheckList).length === 0 && (
                      <OverlayTrigger
                        trigger='click'
                        placement='right'
                        overlay={this.popoverRight()}
                      >
                        <button className='btn btn-primary btn-info btn-siteone btn-icon'>
                          Go
                        </button>
                      </OverlayTrigger>
                    )}
                  {headerAction.value === 1 &&
                    Object.keys(refNoCheckList).length !== 0 && (
                      <button
                        className='btn btn-primary btn-info btn-siteone btn-icon'
                        onClick={this.onClickGoReassignMultiplePopup}
                      >
                        Go
                      </button>
                    )}
                  {headerAction.value === 1 && isDisplayReassignPopup && (
                    <ReassignMultiplePopup
                      onSaveReassignPopup={this.onSaveReassignMultiple}
                      onCancelReassignPopup={
                        this.onClickGoReassignMultiplePopup
                      }
                      userSelectList={this.props.builderUserList}
                      sso={this.props.UserProfile.sso}
                      onFetchUser={this.onFetchUserToReassign}
                    />
                  )}
                </ul>
              </Col>
              <Col sm={8} className='text-right'>
                <ChangeColumn
                  columnList={column}
                  settingColumn={settingColumn}
                  onChangeColumn={this.onChangeColumn}
                />
                <ExportButton onClick={this.handleExport} />
                <div
                  className='box-search'
                  style={{ margin: 0, transform: 'translateY(5px)' }}
                >
                  <div className='input-group'>
                    <input
                      type='text'
                      id='txt-search-email'
                      ref={ref => {
                        this.search = ref;
                      }}
                      value={searchTxt}
                      onChange={this.onChangeSearchTxt}
                      className='form-control'
                      placeholder='RFS#'
                      onKeyPress={this.onEnter.bind(this)}
                    />
                    <span className='input-group-btn'>
                      <button
                        onClick={this.onSearch.bind(this)}
                        className='btn btn-secondary'
                      >
                        <span className='fa fa-search' aria-hidden='true' />
                      </button>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>
            Standard requests for service ({totalRecord})
          </h2>

          <div className='dropdown pull-right'>
            <SplitButtonDropdowns
              label={
                <span>
                  <span className='fa fa-plus icon' /> NEW
                </span>
              }
              onClick={() =>
                this.props.history.push('/request-for-services/add')
              }
              menuItems={[
                {
                  label: 'Scheduled request',
                  onClick: () =>
                    this.props.history.push(
                      '/request-for-services/add-schedule-request'
                    )
                }
              ]}
            />
            {/*<button className='btn btn-primary btn-info btn-siteone btn-icon dropdown-toggle' type='button' data-toggle='dropdown'>
                New <span className='caret' />
          </button>
          <ul className='dropdown-menu'>
            <li><Link to={'/request-for-services/add'} style={{cursor: 'pointer'}}>Request</Link></li>
            <li><Link to={'/request-for-services/add-schedule-request'} style={{cursor: 'pointer'}}>Schedule Request</Link></li>
          </ul>*/}
          </div>
        </div>

        <RFSFilter
          onFetchRegion={this.onFetchRegion}
          RegionSelectList={this.props.SelectListRegions}
          onFetchMarket={this.onFetchMarket}
          MarketSelectList={this.props.SelectListMarkets}
          onFetchProject={this.onFetchProject}
          ProjectSelectList={this.props.SelectListProjects}
          onFetchRFSManagedBy={this.onFetchRFSManagedBy}
          RFSManagedBySelectList={this.props.builderUserList}
          onSearchRFS={this.onSearchRFS}
          // RequestTypeSelectList={[]}
          onFetchRequestType={this.onFetchRequestType}
          RequestTypeSelectList={this.props.SelectListRequestType}
          onFetchLot={this.onFetchLot}
          LotSelectList={this.props.SelectListLots}
          sso={this.props.UserProfile.sso}
          location={this.props.location}
          onFetchCreatedBy={this.onFetchCreatedBy}
          CreatedByList={this.props.CreatedByList}/>

        {this.props.UserProfile.userId && (
          <TableList
            ref={ref => {
              this.tableList = ref;
            }}
            column={column}
            defaultParams={defaultParams}
            data={data}
            options={options}
            refreshPageList={this.refreshList.bind(this)}
            refreshList={this.refreshList.bind(this)}
            onContextMenu={this.onContextMenu.bind(this)}
            showButtonMenu={true}
            caretRender={this.getCaret}
            customTableHeader={customHeader}
            isDisplayTable={isDisplayTable}
            applySkeleton={true}
          />
        )}

        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />

        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.LOGO_30}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    UserProfile: state.UserStore.UserProfile,
    SettingDataGridColumn: state.BuilderStore.SettingDataGridColumn,
    ManagerStore: state.RFSStore,
    SelectListRegions: state.RFSStore.SelectListRegions,
    SelectListMarkets: state.RFSStore.SelectListMarkets,
    SelectListProjects: state.RFSStore.SelectListProjects,
    builderUserList: state.authReducer.builderUserList,
    SelectListRequestType: state.RFSStore.SelectListRequestType,
    SelectListLots: state.RFSStore.SelectListLots,
    PageSizeReference: state.BuilderStore.PageSizeReference,
    CreatedByList:state.RFSStore.CreatedByList
  };
};

export default connect(mapStateToProps)(ManageRFS);



// WEBPACK FOOTER //
// ./src/Request-Services/Containers/manage-rfs.js